import { inject, injectable } from "inversify";
import { DependencyType } from "@di/DependencyType";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import {
  CreateCultivationDocument,
  CreateCultivationInput,
  CreateCultivationMutation,
  CreateCultivationMutationVariables,
  CultivationsDocument,
  CultivationsQuery,
  CultivationsQueryVariables,
} from "generated/graphql";

@injectable()
export class CultivationService {
  constructor(
    @inject(DependencyType.ApolloClient)
    private readonly apolloClient: ApolloClient<NormalizedCacheObject>
  ) {}

  async findAll() {
    const queryTuple = await this.apolloClient.query<
      CultivationsQuery,
      CultivationsQueryVariables
    >({
      query: CultivationsDocument,
    });

    if (queryTuple.errors) {
      throw new Error(queryTuple.errors[0].message);
    }

    return queryTuple.data.cultivations;
  }

  async create(input: CreateCultivationInput) {
    const mutationTuple = await this.apolloClient.mutate<
      CreateCultivationMutation,
      CreateCultivationMutationVariables
    >({
      mutation: CreateCultivationDocument,
      variables: {
        input,
      },
      refetchQueries: [
        {
          query: CultivationsDocument,
        },
      ],
      awaitRefetchQueries: true,
    });

    if (mutationTuple.errors) {
      throw new Error(mutationTuple.errors[0].message);
    }

    return mutationTuple.data?.createCultivation;
  }
}
